// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2195":"e1dabc78","3718":"2055e3a8"}[chunkId] + ".chunk.css";
};